import { EmptyObject } from "./utility";

export interface AccountSwitchResponse {
  location: string;
  projectSid: string;
  statusCode: number;
}

export interface GetSubAccountsQueryParams {
  status?: SubAccountStatus;
  pageSize?: number;
  search?: string;
  pageToken?: string;
}

export enum SubAccountStatus {
  open = "2",
  suspended = "4,16,32",
  closed = "8",
  all = "all",
}

export interface Subaccount {
  sid: string;
  friendlyName: string;
  status: SubAccountStatus;
  iamRoles: string[];
}

export interface GetSubAccountsResponse {
  content: Subaccount[];
  meta: {
    next_token: "string";
    previous_token: "string";
    page_size: number;
  };
}

export interface FeatureFlagsResponse {
  errorCode?: string;
  message?: string;
  result: string[];
  statusCode: number;
  success: boolean;
}

export interface ErrorResponseIdConsole {
  code: number;
  message: string;
  params: EmptyObject;
}
